<template>
  <div class="d-flex align-center channel-container">
    <v-btn v-if="showDelete" icon small class="delete-btn" @click.stop="$emit('delete', channel)">
      <v-icon small color="red">mdi-delete</v-icon>
    </v-btn>
    <v-avatar size="90" class="channel-avatar">
      <v-img :src="channel.image" />
    </v-avatar>
    <div class="d-flex flex-column mx-3">
      <span class="text-h6 font-weight-bold channel-name">{{ channel.name }}</span>
      <span class="text-body-1 channel-followers">
        {{ formatFollowers(channel.followers) }} {{ $t('followers') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    channel: {
      id: Number,
      image: String,
      name: String,
      followers: Number,
    },
    showDelete: { type: Boolean, default: false },
  },
  methods: {
    formatFollowers(count) {
      count = count || 0;

      if (count >= 1000000) {
        return `${(count / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
      }
      if (count >= 1000) {
        return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}k`;
      }

      return `${count}`;
    },
  },
};
</script>

<style scoped>
.channel-container {
  width: fit-content;
  position: relative;
}
.delete-btn {
  position: absolute;
  top: 4px;
  inset-inline-start: 4px;
  z-index: 2;
  background-color: white;
}
.channel-avatar {
  border-radius: 50%;
  overflow: hidden;
}
.channel-name {
  max-width: 220px;
}
.channel-followers {
  max-width: 220px;
}
</style>
